import React, { useMemo, useState, useEffect } from 'react';
import { useTable } from 'react-table';
import Pagination from "../../../components/shared/pagination/index";
import '../../../../src/index.css'; 
import { getScales, deleteScaleId, updateScaleId, createScale } from '../../../client/administration/scale/index'; 
import { getSites } from '../../../client/administration/sites/index';
import { getStands } from '../../../client/administration/stands/index';
import { getScaleModel } from '../../../client/administration/scaleModel/index';
import { RiPencilLine, RiAddFill, RiDeleteBin5Line } from "react-icons/ri";
import AddData from '../../shared/alertRegisterData/index';
import DeleteData from '../../shared/alertDeleteData/index';
import EditData from 'components/shared/alertEditData';
import buttonClose from '../../../assets/images/shared/modals/button-close.svg'
import InputField from 'components/forms/inputField';
import SelectField from 'components/forms/selectField';

const TableScale = ({ recordsPerPage, data, filterCode, currentPage, setCurrentPage, filterPlant, searchTerm, onSearchTermChange,  showModalAddScale, closeModalAddScale }) => {

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [scales, setScales] = useState([]);

  const totalRecords = scales.length;

  const [scaleCode, setScaleCode] = useState('');
  const [serialCode, setSerialCode] = useState('');
  const [idStand, setIdStand] = useState('');
  const [idScaleModel, setIdScaleModel] = useState('');
  const [area, setArea] = useState('');
  
  const [showModalAddData, setShowModalAddData] = useState(false);

  const [editingScale, setEditingScale] = useState(null); 
  const [showEditConfirmModal, setShowEditConfirmModal] = useState(false);
  const [showModalEditScale, setShowModalEditScale] = useState(false); 

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [scaleToDelete, setScaleToDelete] = useState(null);

  const [errors, setErrors] = useState({
    scaleCode: false,
    serialCode: false,
    area: false,
    idStand: false,
    idScaleModel: false,
  });


  /**OBTENER REGISTROS */
  useEffect(() => {
    const fetchScales = async () => {
      setLoading(true);
      try {
        const { data } = await getScales();
        setScales(data);
        setError(null);
      } catch (err) {
        setError(err.message || "Error al cargar los datos");
      } finally {
        setLoading(false);
      }
    };

    fetchScales();
  }, []);

/************** FILTROS DE BUSQUEDA  *******************/

  useEffect(() => {
    const filteredData = data.filter(scale => {
   // console.log("Filtro de planta:", filterPlant); 
   // console.log("Datos de escala:", scale);
    const matchesCode = filterCode ? 
    scale.scaleCode.includes(filterCode) : true;
    const matchesPlant = filterPlant ? 
      scale.stand && 
      scale.stand.site && 
      scale.stand.site.siteName && 
      scale.stand.site.siteName.toLowerCase().includes(filterPlant.toLowerCase()) : true;
    //  console.log("Coincidencia de planta:", matchesPlant); 
    //  console.log("s planta:", scale.stand.site.siteName);
    const matchesSearchTerm = searchTerm ? 
    scale.scaleCode.toLowerCase().includes(searchTerm.toLowerCase()) ||
    scale.serialCode.toLowerCase().includes(searchTerm.toLowerCase()) ||
    scale.area.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (scale.stand && scale.stand.standName && scale.stand.standName.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (scale.stand && scale.stand.site && scale.stand.site.siteName && scale.stand.site.siteName.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (scale.stand && scale.stand.direction && scale.stand.direction.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (scale.scaleModel && scale.scaleModel.modelName && scale.scaleModel.modelName.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (scale.scaleModel && scale.scaleModel.scaleBrand && scale.scaleModel.scaleBrand.brandName && scale.scaleModel.scaleBrand.brandName.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (scale.scaleModel && scale.scaleModel.maximunCapacity && scale.scaleModel.maximunCapacity.toString().includes(searchTerm)) ||
    (scale.scaleModel && scale.scaleModel.minimunCapacity && scale.scaleModel.minimunCapacity.toString().includes(searchTerm)) : true;

      return matchesCode && matchesPlant && matchesSearchTerm;
    });

    setScales(filteredData);
    setLoading(false);
  }, [data, filterCode, filterPlant, searchTerm]); 
  
  /*********AGREGAR REGISTROS***********/


  const handleSaveScale = async () => {

    const newErrors = {
      scaleCode: !scaleCode || scaleCode.length < 3 || scaleCode.length > 45,
      serialCode: !serialCode || serialCode.length < 3 || serialCode.length > 45,
      area: !area || area.length < 3 || area.length > 45,
      idStand: !idStand,
      idScaleModel: !idScaleModel,
    };

    setErrors(newErrors);
    // Si hay algún error, no continuar
    if (Object.values(newErrors).some(error => error)) {
      return;
    }
    
    const newScale = {
      scaleCode: scaleCode,
      serialCode: serialCode,
      area: area,
      idStand: parseInt(idStand, 10),
      idScaleModel: parseInt(idScaleModel, 10),
      
    };
   // console.log("Datos a enviar:", newScale); 
    try {
      const { data } = await createScale(newScale); 
      const {data: updatedScales} = await getScales();
      setScales(updatedScales);
      setScaleCode('');
      setSerialCode('');
      setArea('');
      setIdStand('');
      setIdScaleModel('');
     // setShowModalAddScale(false);
      closeModalAddScale();
      setShowModalAddData(true);

      onSearchTermChange(searchTerm);
    } catch (err) {
    //  console.log("Error al agregar la balanza: " + err.message);
    }
  };

  /***********************EDIT SCALE**********/

  const openModalEditScale = () => {
    setShowModalEditScale(true);
  };

  const closeModalEditScale = () => {
    setShowModalEditScale(false);
    setEditingScale(null);
  };
  const [editedScale, setEditedScale] = useState({
    id: '',
    scaleCode: '',
    serialCode: '',
    area: '',
    idStand: '',
    idScaleModel: '',
  });

  const handleEditClick = (row) => {
    setEditingScale(row);
    setEditedScale({
      id: row.original.id,
      scaleCode: row.original.scaleCode,
      serialCode: row.original.serialCode,
      area: row.original.area,
      idStand: row.original.idStand,
      idScaleModel: row.original.idScaleModel,
    });
   // console.log(row.original);
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {
      scaleCode: !editedScale.scaleCode || editedScale.scaleCode.length < 3 || editedScale.scaleCode.length > 45,
      serialCode: !editedScale.serialCode || editedScale.serialCode.length < 3 || editedScale.serialCode.length > 45,
      area: !editedScale.area || editedScale.area.length < 3 || editedScale.area.length > 45,
      idStand: !editedScale.idStand,
      idScaleModel: !editedScale.idScaleModel,
    };
    setErrors(newErrors);
    if (Object.values(newErrors).some(error => error)) {
        return;
    }
    setShowEditConfirmModal(true);
  };

  /***************DELETE SCALE********************/
  const deleteScaleHandler = (row) => {
  //  console.log("Registro seleccionado para eliminar:", row.original);
    setScaleToDelete(row.original); 
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      if (!scaleToDelete?.id) throw new Error("ID no encontrado");
      await deleteScaleId(scaleToDelete.id); // Usa el id para la eliminación en el backend
      setScales(prevData => prevData.filter(item => item.id !== scaleToDelete.id)); // Actualiza la tabla localmente
      setShowDeleteModal(false); 
  } catch (error) {
      console.error("Error al eliminar:", error);
      alert("No se pudo eliminar el registro.");
  }
  };
  
  /***************OBTENER LISTA MODELOS********************/
  const [scaleModels, setScaleModels] = useState([]);
  useEffect(() => {
    const fetchModel = async () => {
      try {
        const { data } = await getScaleModel(); 
        setScaleModels(data);
      } catch (err) {
        setError(err.message || "Error al cargar los modelos");
      }
    };
    fetchModel();
  }, []);

//************ OBTENER LISTA DE STANDS ****************/
  const [stands, setStands] = useState([]);

  useEffect(() => {
    const fetchStands = async () => {
      try {
        const { data } = await getStands(); 
        setStands(data);
      } catch (err) {
        setError(err.message || "Error al cargar los stands");
      }
    };
    fetchStands();
  }, []);
  /***************OBTENER LISTA PLANTAS********************/
  const [sites, setSites] = useState([]);
  useEffect(() => {
    const fetchSites = async () => {
      try {
        const { data } = await getSites(); 
        setSites(data);
      } catch (err) {
        setError(err.message || "Error al cargar las plantas");
      }
    };
    fetchSites();
  }, []);

  // Filtrar los sites que tengan los stands
  const filteredSites = stands.map(stand => stand.site).filter((site, index, self) =>
    index === self.findIndex((s) => s.siteName === site.siteName)
  );


const totalPages = Math.ceil(totalRecords / recordsPerPage);

const changePage = (newPage) => {
  if (newPage >= 1 && newPage <= totalPages) {
    setCurrentPage(newPage);
  }
};

/************* COLUMNAS********* */
  const columns = useMemo(
    () => [
    { Header: 'ID', accessor: 'id', style: { width: '50px' } },
    { Header: 'Planta', accessor: 'stand.site.siteName',  style: { width: '130px' }  },
    { Header: 'Ubicación', accessor: 'stand.site.direction',  style: { width: '200px' }  },
    { Header: 'Código', accessor: 'scaleCode',  style: { width: '150px' }  },
    { Header: 'Marca' , accessor: 'scaleModel.scaleBrand.brandName',  style: { width: '100px' } },
    { Header: 'Modelo', accessor: 'scaleModel.modelName' ,  style: { width: '150px' } },
    { Header: 'Serie', accessor: 'serialCode' ,  style: { width: '150px' }  },
    { Header: 'Área', accessor: 'area' ,  style: { width: '150px' }  },
    { Header: 'Capacidad Min', accessor: 'scaleModel.minimunCapacity',  style: { width: '130px' }  },
    { Header: 'Capacidad Max', accessor: 'scaleModel.maximunCapacity' ,  style: { width: '130px' } },
    { Header: 'Fecha de registro', accessor: 'createdAt' ,  style: { width: '130px' } ,
    Cell: ({ value }) => {
      const date = new Date(value); 
      const formattedDate = date.toISOString().slice(0, 10); 
      const formattedTime = date.toTimeString().slice(0, 5); 
      return `${formattedDate} ${formattedTime}`;
    },},
      {
        Header: 'Editar',
        accessor: 'editar',
        style: { width: '90px' },
        Cell: ({ row }) => (
          <div className="flex items-center justify-center">
            <button
              onClick={() => handleEditClick(row)}
              className="p-2 flex justify-center items-center  hover:bg-[#D8D7E0]  bg-[#EFEEF7] rounded-[4px] border border-[#D9D9D9] w-12 h-12"
            >
              <RiPencilLine className="text-xl text-black" />
            </button>
          </div>
        ),
      },
      {
        Header: 'Eliminar',
        accessor: 'eliminar',
        style: { width: '90px' },
        Cell: ({ row }) => (
          <div className="flex items-center justify-center">
            <button
              onClick={() => deleteScaleHandler(row)}
              className="p-2 flex justify-center items-center  hover:bg-[#D8D7E0]  bg-[#EFEEF7] rounded-[4px] border border-[#D9D9D9] w-12 h-12"
            >
              <RiDeleteBin5Line className="text-xl text-black" />
            </button>
          </div>
        ),
      },
  ], []);

  
  const indexOfLastScale = currentPage * recordsPerPage;
  const indexOfFirstScale = indexOfLastScale - recordsPerPage;
  const currentScales = scales.slice(indexOfFirstScale, indexOfLastScale);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable(
    {
      columns,
      data: currentScales,
      initialState: { pageIndex: 0, pageSize: recordsPerPage || 10 },
    },
  );


 //if (loading) return <p>Cargando datos...</p>;
 if (error) {
  return (
    <div className='items-center justify-center w-full min-h-full pt-16'>
      <p className='pt-4 text-2xl text-center text-error font-itcmedium'>
        Hubo un error al recuperar los datos.
      </p>
    </div>
  );
}

  return (
    <div className="w-full pt-4">
      {/**
      <button
        onClick={openModalAddScale}
        className="flex items-center justify-center h-[40px] p-3 px-5 mb-4 space-x-4 text-white rounded-md bg-green"
      >
        <RiAddFill className="flex text-[14px] font-itcmedium" /> 
          Agregar balanza
      </button>
 */}
      { !error && scales.length === 0 && (
        <div className='flex items-center justify-center w-full'>
         <p className='pt-4 text-xl text-center font-itcmedium'>No se hallaron registros.</p>
        </div>
      )}

      
      {/* ADD SCALE */}
      {showModalAddScale && (
        <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
          <div className="lg:w-[40%] w-[90%] h-auto p-2 bg-white rounded-3xl shadow-lg flex flex-col">
            <div className="flex justify-end">
              <button
                onClick={closeModalAddScale}
                className="px-1 py-0 rounded-md"
              >
                <img src={buttonClose} alt="Cerrar"/>
              </button>
            </div>
            <div className="flex flex-col items-center justify-center px-4 pb-4 space-y-4">
              <div className="flex justify-center w-full">
                <h1 className="mb-4 text-2xl text-blue font-itcbold">Agregar balanza</h1>
              </div>
              <div className="justify-center flex flex-col gap-4 w-[85%]">
                <InputField
                  value={scaleCode}
                  placeholder="Código"
                  onChange={(e) => {
                    setScaleCode(e.target.value);
                    setErrors((prevErrors) => ({ ...prevErrors, scaleCode: false }));
                  }}
                  error={errors.scaleCode}
                  errorMessage= "Campo obligatorio"
                  minLength={3}
                  maxLength={45}
                  required
                />

                <InputField
                  value={serialCode}
                  placeholder="Serie"
                  onChange={(e) => {
                    setSerialCode(e.target.value);
                    setErrors(prevErrors => ({ ...prevErrors, serialCode: false }));
                  }}
                  error={errors.serialCode}
                  errorMessage= "Campo requerido"
                  minLength={3}
                  maxLength={45}
                  required
                />

                <InputField
                  value={area}
                  placeholder="Área"
                  onChange={(e) => {
                    setArea(e.target.value);
                    setErrors(prevErrors => ({ ...prevErrors, area: false }));
                  }}
                  error={errors.area}
                  errorMessage= "Campo requerido"
                  minLength={3}
                  maxLength={45}
                  required
                />

                <SelectField
                  value={idStand}
                  options={filteredSites.map((site) => ({
                    value: site.id,
                    label: site.siteName
                  }))}
                  onChange={(e) => {
                    setIdStand(e.target.value);
                    setErrors((prevErrors) => ({ ...prevErrors, idStand: false }));
                  }}
                  error={errors.idStand}
                  errorMessage="Campo requerido"
                  required
                  placeholder="Planta"
                />

                <SelectField
                  value={idScaleModel}
                  options={scaleModels.map((scaleModel) => ({
                    value: scaleModel.id,
                    label: scaleModel.modelName
                  }))}
                  onChange={(e) => {
                    setIdScaleModel(e.target.value);
                    setErrors((prevErrors) => ({ ...prevErrors, idScaleModel: false }));
                  }}
                  error={errors.idScaleModel}
                  errorMessage="Campo requerido"
                  required
                  placeholder="Modelo"
                />

              </div>
              <div className="flex w-full py-4 sm:px-[7.5%] justify-between gap-2">
              <button 
                onClick={handleSaveScale}
                className="w-[160px] inline-block sm:h-[43px] h-[46px] text-md text-center text-white bg-green rounded-2xl font-itcdemi"
              >
                Guardar
              </button>
              <button
                onClick={closeModalAddScale}
                className="w-[160px] inline-block sm:h-[43px] h-[46px] text-md text-center bg-white border-2 text-green rounded-2xl font-itcdemi border-green"
              >
                Cancelar
              </button>
            </div>
            </div>
            
          </div>
        </div>
      )}
      {/* Modal de éxito */}
      {showModalAddData && (
        <AddData
          showModalAddData={showModalAddData}
          closeModalAddData={() => setShowModalAddData(false)}
        />
      )}

      {/* TABLA  DE BALANZAS */}
      {!error && scales.length > 0 && (
        <>
          <div className="max-w-full overflow-x-auto scroll-container">
            <table {...getTableProps()} className="w-full border-collapse table-fixed">
              <thead className="bg-white">
                {headerGroups.map(headerGroup => (
                  <tr {...headerGroup.getHeaderGroupProps()} className="text-sm text-center font-itcbold">
                    {headerGroup.headers.map(column => (
                      <th
                        {...column.getHeaderProps()}
                        style={column.style}
                        className="px-4 py-2 border border-[#D9D9D9]"
                      >
                        {column.render('Header')}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()} className="table-row-group">
                {rows.map((row, index) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()} className={`text-sm border-collapse h-full font-itcbook text-left ${row.index % 2 === 0 ? 'bg-white' : 'bg-[#EBEBEB]/[0.2]'}`}>
                      {row.cells.map(cell => (
                        <td {...cell.getCellProps()} className="px-4 py-2 border border-[#D9D9D9]">
                          {cell.render('Cell')}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="flex items-center justify-between mt-6 space-x-4">
        <p className="text-[#1F2A37] text-sm font-itcbook">
        Mostrando registros del {(currentPage - 1) * recordsPerPage + 1} al{' '}
          {Math.min(currentPage * recordsPerPage, totalRecords)} de un total de {totalRecords} registros

        </p>

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          changePage={changePage}
        />
          </div>
        </>
      )}

      {/* EDIT SCALE */}
      {editingScale && (
        <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
          <div className="lg:w-[40%] w-[90%] h-auto p-2 bg-white rounded-3xl shadow-lg flex flex-col">
            <div className="flex justify-end">
              <button
                onClick={closeModalEditScale}
                className="px-1 py-0 rounded-md"
              >
                <img src={buttonClose} alt="Cerrar"/>
              </button>
            </div>
            <div className='flex flex-col items-center justify-center px-4 pb-4 space-y-4'>
              <div className='flex justify-center w-full'>
                <h1 className="mb-4 text-2xl font-bold text-blue font-itcbold">Editar Balanza</h1>
              </div>
              <form onSubmit={handleEditSubmit} className=' w-[85%] justify-center' >
                <div className='flex flex-col gap-4'>
                  <InputField
                    value={editedScale.scaleCode}
                    placeholder="Código"
                    onChange={(e) =>
                      setEditedScale((prevState) => ({
                        ...prevState,
                        scaleCode: e.target.value,
                      }))
                    }
                    error={errors.scaleCode}
                    errorMessage="Campo requerido"
                    minLength={3}
                    maxLength={45}
                    required
                  />

                  <InputField
                    value={editedScale.serialCode}
                    placeholder="Serie"
                    onChange={(e) =>
                      setEditedScale((prevState) => ({
                        ...prevState,
                        serialCode: e.target.value,
                      }))
                    }
                    error={errors.serialCode}
                    errorMessage="Campo requerido"
                    minLength={3}
                    maxLength={45}
                    required
                  />

                  <InputField
                    value={editedScale.area}
                    placeholder="Área"
                    onChange={(e) =>
                      setEditedScale((prevState) => ({
                        ...prevState,
                        area: e.target.value,
                      }))
                    }
                    error={errors.area}
                    errorMessage="Campo requerido"
                    minLength={3}
                    maxLength={45}
                    required
                  />

                  <SelectField
                    value={editedScale.idStand}
                    options={filteredSites.map((site) => ({
                      value: site.id,
                      label: site.siteName,
                    }))}
                    onChange={(e) =>
                      setEditedScale((prevState) => ({
                        ...prevState,
                        idStand: e.target.value,
                      }))
                    }
                    error={errors.idStand}
                    errorMessage="Campo requerido"
                    required
                    placeholder="Planta"
                  />
              
                  <SelectField
                    value={editedScale.idScaleModel}
                    options={scaleModels.map((scaleModel) => ({
                      value: scaleModel.id,
                      label: scaleModel.modelName,
                    }))}
                    onChange={(e) =>
                      setEditedScale((prevState) => ({
                        ...prevState,
                        idScaleModel: e.target.value,
                      }))
                    }
                    error={errors.idScaleModel}
                    errorMessage="Campo requerido"
                    required
                    placeholder="Modelo"
                  />
                                
                </div>
                <div className="flex justify-between w-full gap-2 py-4 pt-8">
                <button 
                    type="submit"
                    className="w-[160px] inline-block sm:h-[43px] h-[46px] text-md text-center text-white bg-green rounded-2xl font-itcdemi">
                        Guardar
                  </button> 
              
                  <button type="button"
                      onClick={() => setEditingScale(null)}
                      className="w-[160px] inline-block sm:h-[43px] h-[46px] text-md text-center bg-white border-2 text-green rounded-2xl font-itcdemi border-green">
                        Cancelar
                  </button>   
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      {showEditConfirmModal && (
          <EditData
              showModalEditData={showEditConfirmModal}
              closeModalEditData={() => setShowEditConfirmModal(false)}
              codbalanza={editedScale.scaleCode}
              context="Balanza"
              onConfirm={async () => {
                  try {
                      await updateScaleId(editedScale.id, {
                          scaleCode: editedScale.scaleCode,
                          serialCode: editedScale.serialCode,
                          area: editedScale.area,
                          idStand: editedScale.idStand,
                          idScaleModel: editedScale.idScaleModel,
                      });
                      const {data: updatedScales} = await getScales();
                      setScales(updatedScales);
                      setEditingScale(null);
                      setShowEditConfirmModal(false); 
                  } catch (err) {
                      setError("Error al actualizar el registro: " + err.message);
                      alert("Hubo un error al intentar actualizar el registro.");
                  }
              }}
          />
      )}

      {/** DELETE SCALE */}
      {showDeleteModal && (
        <DeleteData
          showModalDeleteData={showDeleteModal}
          closeModalDeleteData={() => setShowDeleteModal(false)}
          codbalanza={scaleToDelete?.scaleCode} 
          context="Balanza"
          confirmDelete={confirmDelete}
        />
      )}

    </div>
  );
};

export default TableScale;
